// extracted by mini-css-extract-plugin
module.exports = {"Placeholder":"#CDCCCC","overlay":"LoaderOverlay_overlay__sG3QI","children":"LoaderOverlay_children__1Sg74","loader":"LoaderOverlay_loader__2R9aB"};